/* eslint-disable */
export default {
  to: 'A:',
  transferTo: 'Trasferisci a',
  blindTransfer: 'Trasferisci',
  warmTransfer: 'Chiedi prima',
  enterNameOrNumber: 'Immetti numero',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"transferTo"@#@ @source: @#@"Transfer to"@#@
// @key: @#@"blindTransfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"warmTransfer"@#@ @source: @#@"Ask first"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number"@#@
